<template>
    <el-dialog ref="memberDialog" :before-close="handleDialogClose" :close-on-click-modal="false" :title="projectMemberId ? '编辑成员' : '添加成员'" :visible.sync="memberDialog" class="custom-form-dialog custom_dialog" width="520px">
        <div class="detail">
            <el-form ref="formData" :model="formData" :rules="formRules" label-position="top">
                <el-form-item label="项目成员" prop="member_uid">
                    <el-select  :remote-method="getUserList" class="el_select_change" filterable placeholder="请选择项目成员"  remote v-model="formData.member_uid" multiple>
                        <el-option v-for="(user, index) in userList" :key="user.uid" :label="user.name" :value="user.uid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="角色名称" prop="member_role">
                    <el-input size="small" v-model="formData.member_role"   placeholder="请输入角色名称" ></el-input>
                </el-form-item>
                <el-form-item label="成员权限" prop="permission_range" class="label-bold">
                    <div class="permission_range_wrap">
                        <div class="permission_range_top">
                            <el-checkbox  v-model="checkAll" @change="handleCheckAllChange"><h5>全部权限</h5></el-checkbox>
                        </div>
                        <div class="permission_range_bottom">
                            <el-checkbox-group v-model="formData.permission_range" @change="handleCheckedChange">
                                <div class="look_item">
                                    <h5>项目详情-业务相关</h5>
                                    <el-switch  :value="formData.permission_range.indexOf('business_related_detail') > -1" @change="handleSwitchChange('business_related_detail')" active-color="#2990FF"></el-switch>
                                </div>
                                <template v-if="formData.permission_range.indexOf('business_related_detail') > -1">
                                    <div class="checkbox_item"><el-checkbox  label="business_manage" key="business_manage">管理权限（可新增或关联商机、订单、工单）</el-checkbox></div>
                                </template>

                                <div class="look_item">
                                    <h5>项目详情-财务相关</h5>
                                    <el-switch  :value="formData.permission_range.indexOf('financial_related_detail') > -1" @change="handleSwitchChange('financial_related_detail')" active-color="#2990FF"></el-switch>
                                </div>
                                <template v-if="formData.permission_range.indexOf('financial_related_detail') > -1">
                                    <div class="checkbox_item"><el-checkbox  label="financial_payment" key="financial_payment">可查看项目回款/开票数据</el-checkbox></div>
                                    <div class="checkbox_item"><el-checkbox  label="financial_profit" key="financial_profit">可查看项目实际利润/项目成本数据</el-checkbox></div>
                                    <div class="checkbox_item"><el-checkbox  label="financial_cost" key="financial_cost">可新增/编辑/删除项目成本</el-checkbox></div>
                                </template>

                                <div class="look_item">
                                    <h5>项目详情-库存相关</h5>
                                    <el-switch  :value="formData.permission_range.indexOf('inventory_related_detail') > -1" @change="handleSwitchChange('inventory_related_detail')" active-color="#2990FF"></el-switch>
                                </div>
                                <template v-if="formData.permission_range.indexOf('inventory_related_detail') > -1">
                                    <div class="checkbox_item"><el-checkbox  label="inventory_total_cost" key="inventory_total_cost">可查看产品成本总价</el-checkbox></div>
                                </template>

                                <div class="look_item">
                                    <h5>项目详情-项目成员</h5>
                                    <el-switch  :value="formData.permission_range.indexOf('member_related_detail') > -1" @change="handleSwitchChange('member_related_detail')" active-color="#2990FF"></el-switch>
                                </div>
                                <template v-if="formData.permission_range.indexOf('member_related_detail') > -1">
                                    <div class="checkbox_item"><el-checkbox  label="member_operate" key="member_operate">添加成员/操作权限</el-checkbox></div>
                                </template>

                                <div class="look_item">
                                    <h5>项目详情-项目资料</h5>
                                    <el-switch  :value="formData.permission_range.indexOf('project_file_detail') > -1" @change="handleSwitchChange('project_file_detail')" active-color="#2990FF"></el-switch>
                                </div>
                                <template v-if="formData.permission_range.indexOf('project_file_detail') > -1">
                                    <div class="checkbox_item"><el-checkbox  label="project_file_operate" key="project_file_operate">上传/操作权限</el-checkbox></div>
                                </template>

                            </el-checkbox-group>
                        </div>

                    </div>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUserList,ProjectManageMemberAdd,  ProjectManageMemberEdit} from "@/api/index.js"
export default {
    name: "member_tpl",
    components: {

    },
    props: {
        memberDialog: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        projectMemberId: {
            type: Number,
            default: 0
        },
        projectMemberInfo: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                member_uid:[],
                member_role:'',
                permission_range:[]
            },
            formRules: {
                member_uid: [{required: true, message: "请选择项目成员", trigger: 'change'}],
                member_role: [{required: true, message: "请输入角色名称", trigger: 'blur'}],
            },
            userList:[],
            checkAll:false,//是否全选
            allOptions:[
                    'business_related_detail',
                    'business_manage',
                    'financial_related_detail',
                    'financial_payment',
                    'financial_profit',
                    'financial_cost',
                    'inventory_related_detail',
                    'inventory_total_cost',
                    'member_related_detail',
                    'member_operate',
                    'project_file_detail',
                    'project_file_operate'
                ]

        }
    },
    created() {
        if(this.projectMemberInfo){
            this.formData.member_uid = this.projectMemberInfo.members.map(item=>{
                return item.member_uid
            })
            this.userList = this.projectMemberInfo.members.map(item=>{
                return {uid:item.member_user.id,name:item.member_user.name}
            })
            this.formData.permission_range = this.projectMemberInfo.permission_range
            this.formData.member_role = this.projectMemberInfo.member_role

            if(this.allOptions.length == this.formData.permission_range.length){
                this.checkAll = true
            }
        }else{
            this.getUserList()
        }


    },
    methods: {
        // 全选
        handleCheckAllChange(val){
            this.formData.permission_range = val ? JSON.parse(JSON.stringify(this.allOptions)) : [];
        },
        // 选择
        handleCheckedChange(value){
            let length = value.length;
            if(length == this.allOptions.length){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        handleSwitchChange(value){
          let index = this.formData.permission_range.indexOf(value)
            if(index > -1){
                this.formData.permission_range.splice(index, 1)
            }else{
                this.formData.permission_range.push(value)
            }

            if(this.formData.permission_range.length == this.allOptions.length){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        handleDialogClose() {
            this.$emit("update:memberDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = JSON.parse(JSON.stringify(this.formData))
                    postData.project_manage_id = this.projectId
                    if(this.projectMemberId){
                        postData.id = this.projectMemberId
                        ProjectManageMemberEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit('success')
                                this.$emit('update:memberDialog', false)
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }else{
                        ProjectManageMemberAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit('success')
                                this.$emit('update:memberDialog', false)
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }
                }
            })
        },


    }
}
</script>
<style lang="scss" scoped>
    .custom_dialog{
        ::v-deep .el-dialog__body{
            height: 60vh;
            overflow: auto;
        }
    }
    .permission_range_wrap{
        width: 100%;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(232, 232, 232, 1);
        padding: 0 16px;
        box-sizing: border-box;
        .permission_range_top{
            line-height: 54px;
            border-bottom: 1px solid rgba(232, 232, 232, 1);
            h5{
                display: inline-block;
                margin-left: 0px;
                line-height: 22px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
            }
        }
        .permission_range_bottom{
            width: 100%;
            padding-bottom: 16px;
            .look_item{
                display: flex;
                justify-content: space-between;
                padding-top: 16px;
                line-height: 22px;
                align-items: center;
                h5{
                    color: rgba(51, 51, 51, 1);
                    font-weight: bold;
                    font-size: 14px;
                }
            }
            .checkbox_item{
                margin-top: 10px;
                line-height: 32px;
                .el-checkbox{
                    display: block;
                }
            }
        }
    }
</style>
